import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  Typography,
  Avatar,
  Box,
  Divider,
  IconButton,
  Paper,
  Tabs,
  Tab
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Table from "react-bootstrap/Table";
import { IMAGE_URL } from "../../services/api";
import ProtectedImage from "../../components/ProtectedImage";

const EmployeeProfileView = ({ show, handleClose, selectedEmployee }) => {
  // const baseUrl = "http://localhost:8000";
  const [activeTab, setActiveTab] = useState(0);

  const capitalizeFirstLetter = (str) => {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  const formatAttendanceType = (str) => {
    if (!str) return "N/A";
    return str
      .split("_") // Split string by underscore
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize first letter of each word
      .join(" "); // Join words with spaces
  };

  const EMPLOYMENT_TYPE_LABELS = {
    FT: "Full Time",
    PT: "Part Time",
    CT: "Contract",
    IN: "Intern"
    // Add others as needed
  };

  const Section = ({ title, children }) => (
    <Box mb={3}>
      <Typography variant="h6" gutterBottom sx={{ fontWeight: "bold" }}>
        {title}
      </Typography>
      <Divider sx={{ mb: 2 }} />
      <Grid container spacing={2}>
        {children}
      </Grid>
    </Box>
  );

  const renderField = (label, value) => (
    <Grid item xs={12} sm={6}>
      <Typography variant="body2" color="textSecondary">
        {label}
      </Typography>
      <Typography variant="body1" sx={{ fontWeight: 500, color: "black" }}>
        {value || "N/A"}
      </Typography>
    </Grid>
  );

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Dialog
      open={show}
      onClose={handleClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          height: "100vh",
          width: "100vw",
          maxWidth: "none",
          borderRadius: 2,
          display: "flex",
          flexDirection: "column"
        }
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          px: 3,
          py: 1.5 // maintain default height
        }}
      >
        {/* Left: Employee Name & ID */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          {/* Profile Image or Initials Fallback */}
          {selectedEmployee?.profile_data?.profile_image ? (
            <ProtectedImage
              path={selectedEmployee?.profile_data?.profile_image}
              alt="Profile"
              style={{
      width: 56,
      height: 56,
      borderRadius: "50%",
      objectFit: "cover",
    }}
            />
          ) : (
            // <Box
            //   component="img"
            //   src={
            //     selectedEmployee.profile_data.profile_image.startsWith("data:")
            //       ? selectedEmployee.profile_data.profile_image
            //       : `${IMAGE_URL}${selectedEmployee.profile_data.profile_image}`
            //   }
            //   alt="Profile"
            //   sx={{
            //     width: 56,
            //     height: 56,
            //     borderRadius: "50%",
            //     objectFit: "cover",
            //   }}
            // />
            <Box
              sx={{
                width: 56,
                height: 56,
                borderRadius: "50%",
                backgroundColor: "#1976d2",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#fff",
                fontWeight: "bold",
                fontSize: 20,
                textTransform: "uppercase"
              }}
            >
              {selectedEmployee?.first_name?.[0]}
              {selectedEmployee?.last_name?.[0]}
            </Box>
          )}

          {/* Employee Details */}
          <Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                flexWrap: "wrap"
              }}
            >
              <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                {selectedEmployee?.first_name} {selectedEmployee?.last_name}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                (ID: {selectedEmployee?.employee_id || "N/A"})
              </Typography>
              <Box
                sx={{
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                  backgroundColor: selectedEmployee?.is_active
                    ? "#00cc00"
                    : "red",
                  ml: 0.5
                }}
              />
            </Box>

            <Typography variant="body2" color="text.secondary">
              {selectedEmployee?.profile_data?.designation_name || "N/A"}
            </Typography>
          </Box>
        </Box>

        {/* Right: Company Logo & Name + Close */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <ProtectedImage
            path={selectedEmployee?.company?.company_logo}
            alt={`${selectedEmployee?.company?.company_name}`}
            className="company-logo"
          />
          {/* <Avatar
      variant="square"
      src={
        selectedEmployee?.company?.company_logo
          ? `${IMAGE_URL}${selectedEmployee.company.company_logo}`
          : undefined
      }
      alt="Logo"
      sx={{ width: 40, height: 40 }}
    /> */}
          {/* <Typography variant="body2" sx={{ fontWeight: 500 }}>
      {selectedEmployee?.company?.company_name || "N/A"}
    </Typography> */}
          <IconButton onClick={handleClose} size="small">
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent dividers>
        {selectedEmployee && (
          <Box>
            {/* Tabs */}
            <Tabs
              value={activeTab}
              onChange={handleTabChange}
              variant="scrollable"
              scrollButtons="auto"
            >
              <Tab label="Basic Information" />
              <Tab label="Employment Details" />
              <Tab label="Salary Details" />
              <Tab label="Leave Details" />
              <Tab label="Challan Details" />
              <Tab label="Permissions" />
            </Tabs>

            {/* Tab Content */}
            <Box mt={3}>
              {activeTab === 0 && (
                <Section title="Basic Details">
                  {renderField("Email", selectedEmployee.email)}
                  {renderField("Mobile Number", selectedEmployee.mobile_number)}
                  {renderField(
                    "Gender",
                    capitalizeFirstLetter(selectedEmployee.gender)
                  )}
                  {renderField("Nationality", selectedEmployee.nationality)}
                  {/* {renderField("About", selectedEmployee.about)}
                  {renderField("Location", selectedEmployee.location)} */}
                </Section>
              )}
              {activeTab === 1 && (
                <Section title="Employment Details">
                  {renderField(
                    "Company",
                    selectedEmployee.company?.company_name
                  )}
                  {renderField(
                    "Department",
                    selectedEmployee.profile_data.department_name
                  )}
                  {renderField(
                    "Designation",
                    selectedEmployee.profile_data.designation_name
                  )}
                  {renderField(
                    "Joining Date",
                    selectedEmployee.profile_data.joining_date
                  )}
                  {renderField(
                    "Employment Type",
                    EMPLOYMENT_TYPE_LABELS[
                      selectedEmployee.profile_data.employment_type
                    ] || "N/A"
                  )}

                  {renderField(
                    "Work Location",
                    selectedEmployee.profile_data.work_location
                  )}
                  {renderField(
                    "Reporting Manager",
                    selectedEmployee.profile_data?.reporting_manager
                      ? `${selectedEmployee.profile_data.reporting_manager.first_name} ${selectedEmployee.profile_data.reporting_manager.last_name}`
                      : "N/A"
                  )}
                  {renderField(
                    "Employee status",
                    selectedEmployee.profile_data.employee_status
                  )}
                  <Grid item xs={12}>
                    <Typography
                      variant="h6"
                      gutterBottom
                      sx={{ fontWeight: "bold", mt: 2 }}
                    >
                      Job Role & Work Schedule
                    </Typography>
                    <Divider sx={{ mb: 2 }} />
                  </Grid>
                  <Grid item xs={12}>
                    {renderField(
                      "Job Description",
                      selectedEmployee.profile_data.job_description
                    )}
                  </Grid>
                  {renderField(
                    "Shift Timimng",
                    selectedEmployee.profile_data.shift_timing
                  )}
                  {renderField(
                    "Weekly Off",
                    selectedEmployee.profile_data.weekly_off
                  )}
                  {renderField(
                    "Working Hours",
                    selectedEmployee.profile_data.working_hours
                  )}
                </Section>
              )}
              {activeTab === 2 && (
                <Section title="Salary Details">
                  {renderField(
                    "Basic Salary",
                    selectedEmployee.employee_salary?.basic_salary || "N/A"
                  )}
                  {renderField(
                    "Deduction",
                    selectedEmployee.employee_salary?.deductions
                      ? Object.entries(
                          selectedEmployee.employee_salary.deductions
                        )
                          .map(([key, value]) => `${key}: ${value}`)
                          .join(", ")
                      : "N/A"
                  )}
                  {renderField(
                    "HRA",
                    selectedEmployee.employee_salary?.hra || "N/A"
                  )}
                  {renderField(
                    "Bonus",
                    selectedEmployee.employee_salary?.bonus || "N/A"
                  )}
                  {renderField(
                    "Bank Name",
                    selectedEmployee.employee_salary?.bank_name || "N/A"
                  )}
                  {renderField(
                    "Account Number",
                    selectedEmployee.employee_salary?.account_number || "N/A"
                  )}
                  {renderField(
                    "IFSC Code",
                    selectedEmployee.employee_salary?.ifsc_code || "N/A"
                  )}
                  {renderField(
                    "PAN/TAX ID",
                    selectedEmployee.employee_salary?.pan_number || "N/A"
                  )}
                  {renderField(
                    "UAN/PF Number",
                    selectedEmployee.employee_salary?.pf_number || "N/A"
                  )}
                  {renderField(
                    "ESI Number",
                    selectedEmployee.employee_salary?.esi_number || "N/A"
                  )}
                </Section>
              )}
              {activeTab === 3 && (
                <Section title="Leave Details">
                  {renderField(
                    "Leave Approval Managers",
                    selectedEmployee.leave_balance?.leave_approval_managers
                      ?.length
                      ? selectedEmployee.leave_balance.leave_approval_managers
                          .map(
                            (manager) =>
                              `${manager.first_name} ${manager.last_name}`
                          )
                          .join(", ")
                      : "N/A"
                  )}
                  {renderField(
                    "Attendance Type",
                    formatAttendanceType(
                      selectedEmployee.leave_balance?.attendance_type
                    )
                  )}
                  {renderField(
                    "Leave Year ",
                    selectedEmployee.leave_balance?.leave_year || "N/A"
                  )}
                  {renderField(
                    "Overtime Eligible",
                    selectedEmployee.leave_balance?.overtime_eligible === true
                      ? "Yes"
                      : "No"
                  )}

                  {renderField(
                    "Paid Leave Balance ",
                    selectedEmployee.leave_balance?.paid_leave_balance || "N/A"
                  )}
                  {renderField(
                    "Unpaid Leave Balance",
                    selectedEmployee.leave_balance?.unpaid_leave_balance ||
                      "N/A"
                  )}
                </Section>
              )}
              {activeTab === 4 && (
                <Section title="Challan Details">
                  <Box sx={{ px: 3, width: "100%" }}>
                    <Table
                      striped
                      bordered
                      hover
                      responsive
                      className="challan-table"
                      style={{ width: "100%" }}
                    >
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Challan Name</th>
                          <th>Amount</th>
                          <th>Percentage</th>
                          <th>Applicable Month</th>
                        </tr>
                      </thead>
                      <tbody>
                        {Array.isArray(
                          selectedEmployee?.employee_salary?.challans
                        ) &&
                          selectedEmployee.employee_salary.challans.map(
                            (challan, index) => (
                              <tr key={challan.id}>
                                <td>{index + 1}</td>
                                <td>{challan.name}</td>
                                <td>
                                  {challan.amount !== null
                                    ? challan.amount
                                    : "N/A"}
                                </td>
                                <td>
                                  {challan.percentage !== null
                                    ? `${challan.percentage}%`
                                    : "N/A"}
                                </td>
                                <td>N/A</td>
                              </tr>
                            )
                          )}
                      </tbody>
                    </Table>
                  </Box>
                </Section>
              )}
              {activeTab === 5 && (
                <Section title="Permissions">
                  <Table
                    striped
                    bordered
                    hover
                    responsive
                    className="permissions-table"
                  >
                    <thead>
                      <tr>
                        <th>Module</th>
                        <th>View</th>
                        <th>Edit</th>
                        <th>Create</th>
                        <th>Delete</th>
                        <th>Approve</th>
                        <th>Reject</th>
                        <th>Assign</th>
                        <th>Unassign</th>
                        <th>Export</th>
                        <th>Import</th>
                        <th>Generate Report</th>
                        <th>Archive</th>
                        <th>Restore</th>
                        <th>Enabled</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Array.isArray(
                        selectedEmployee?.permissions?.permissions
                      ) &&
                        selectedEmployee.permissions.permissions.map((perm) => (
                          <tr key={perm.module}>
                            <td className="module-cell">{perm.moduleLabel}</td>
                            {[
                              "view",
                              "edit",
                              "create",
                              "delete",
                              "approve",
                              "reject",
                              "assign",
                              "unassign",
                              "export",
                              "import",
                              "generate_report",
                              "archive",
                              "restore",
                              "enabled"
                            ].map((key) => (
                              <td key={key} className="checkbox-cell">
                                <input
                                  type="checkbox"
                                  readOnly
                                  checked={perm[key]}
                                  className="dark-checkbox readonly-checkbox"
                                />
                              </td>
                            ))}
                          </tr>
                        ))}
                    </tbody>
                  </Table>
                </Section>
              )}
            </Box>
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default EmployeeProfileView;
